import {connect} from "react-redux";
import PayoutDetails from "./PayoutDetails";
import {bindActionCreators} from "redux";
import {documentUploadUrlPublic} from "../../../../../service/fileUpload/action";
import { updateThePayoutDetails, getPayoutDetailsUsingId} from "../../../../../service/Dealer/action";

const mapStateToProps = (state) => ({
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    updatePayoutDetails: state.Dealer.updatePayoutDetails,
    getPayoutDetailsUsingLoanId: state.Dealer.getPayoutDetailsUsingLoanId
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            documentUploadUrlPublic,
            updateThePayoutDetails,
            getPayoutDetailsUsingId
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(PayoutDetails);
